import React from "react";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Grid from "@material-ui/core/Grid";
import classnames from "classnames";
import SearchIcon from "@material-ui/icons/SearchRounded";
import ClearIcon from "@material-ui/icons/ClearRounded";
import { FoodBookLogo } from "../../utils/Constants";

const RestSearch = props => {
  const {
    searchBarShow,
    showLocation,
    hideLocationChange,
    searchText,
    searchTextOnChange,
    showLogo,
    clearSearch,
    classes,
    restaurantName,
    switchRestaurant
  } = props;
  const { SearchBox, Underline, Center, LocationText } = classes;
  document.body.style.overflow = "auto";
  return (
    <Grid item xs style={{ position: "relative" }}>
      {!searchBarShow ? (
        <React.Fragment>
          {!hideLocationChange ? (
            <p
              onClick={switchRestaurant}
              className={LocationText}
              style={{
                paddingTop: "3px"
              }}
            >
              {restaurantName}
            </p>
          ) : null}
        </React.Fragment>
      ) : (
        <TextField
          autoFocus
          value={searchText}
          placeholder="Search Item"
          className={classnames(SearchBox, Center)}
          onChange={searchTextOnChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={classes.adornment}>
                <SearchIcon className={classes.InputIcon} />
              </InputAdornment>
            ),
            endAdornment: (
              <React.Fragment>
                {searchBarShow ? (
                  <InputAdornment
                    position="end"
                    onClick={clearSearch}
                    className={classes.adornment}
                  >
                    <ClearIcon className={classes.InputIcon} />
                  </InputAdornment>
                ) : null}
              </React.Fragment>
            ),
            classes: {
              input: SearchBox,
              underline: Underline
            }
          }}
        />
      )}
    </Grid>
  );
};

export default RestSearch;



// WEBPACK FOOTER //
// ./src/components/AppBar/RestSearch.js